import { DetailRepository } from '@aipb/gulliver/catalog/data-access';
import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { CustomRecordItem, SearchItem } from '@aipb/gulliver/catalog/model';
import { DropboxRepository, DropboxService } from '@aipb/gulliver/dropbox/data-access';
import { ChangeDetectorRef, Directive, EventEmitter, inject, Input, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Directive()
export class ResultListBase {
  @Input() coreId: string;
  @Input() items: CustomRecordItem[] = [];
  @Input({
    required: true
  })
  searchItem: SearchItem;

  @Output() detail: EventEmitter<CustomRecordItem> = new EventEmitter<CustomRecordItem>();
  protected detailRepository = inject(DetailRepository);
  protected dropbox = inject(DropboxService);
  protected dropboxRepository = inject(DropboxRepository);
  protected catalogEnv = inject(CatalogEnvService);
  protected cdr = inject(ChangeDetectorRef);
  private _loading: Subject<boolean> = new BehaviorSubject(false);
  public loading$: Observable<boolean> = this._loading.asObservable();

  selectIsOpened(item: CustomRecordItem): Observable<boolean> {
    return this.detailRepository.selectIsOpened(this.coreId, item);
  }

  selectIsActive(item: CustomRecordItem): Observable<boolean> {
    return this.detailRepository.selectIsActive(this.coreId, item);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected initDropboxImages(callback: () => void = () => {}): void {
    const dropboxItems = this.items
      .filter(
        (i) => i.GulliverRecType === 'Dropbox' && !this.dropboxRepository.getImage(i[this.catalogEnv.env.castor.UUID])
      )
      .map((i) => ({
        id: i[this.catalogEnv.env.castor.UUID],
        path: i.PathDisplay
      }));

    if (dropboxItems.length === 0) {
      callback();
      return;
    }

    this._loading.next(true);
    this.cdr.detectChanges();
    this.dropbox
      .imageDownloadBatch(dropboxItems)
      .pipe(
        finalize(() => {
          this._loading.next(false);
          callback();
          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }
}
